import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import Typography from "@mui/material/Typography"
import React, { useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Checkbox, IconGoogle } from "../../../../components/atoms"
import { AuthContext } from "../../../../contexts/Auth/AuthContext"
import { api } from "../../../../helpers"
import { useApi } from "../../../../hooks/useApi"

import { InputGroup } from "../../../../components/molecules"
import { NotificationContext } from "../../../../contexts/NotificationCTX/NotificationContext"

const theObjectsAreTheSame = (objA: Object, objB: Object) => {
  return JSON.stringify(objA) === JSON.stringify(objB)
}

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  }
}

export function FormDireitos() {
  const [valueBox, setValueBox] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValueBox(newValue)
  }

  const { funcionarioID } = useParams()
  const { getUsuario } = useApi()
  const {
    setType,
    setShow,
    setText: setTextAlert
  } = useContext(NotificationContext)

  const { applicationData } = useContext(AuthContext)

  const [permissao, setPermissao] = useState<Permission>({
    funcionario: Number(funcionarioID),
    login: "",
    status: true,
    nome: ""
  })

  const gravar = async () => {
    const response = await api.post(
      "/api/usuario/editjson",
      {
        vfuncionario: funcionarioID,
        vlogin: permissao.login,
        vrelrecibo: permissao.relrecibo,
        vrelfaturamento: permissao.relfaturamento,
        vrelreserva: permissao.relreserva,
        vempresainc: permissao.empresainc,
        vdestinoinc: permissao.destinoinc,
        vstatus: permissao.status,
        vcidadeinc: permissao.cidadeinc,
        vusuarioinc: permissao.usuarioinc,
        vparceiroinc: permissao.parceiroinc,
        vparceiroalt: permissao.parceiroalt,
        vparceiroesc: permissao.parceiroesc,
        vreservainc: permissao.reservainc,
        vreservaalt: permissao.reservaalt,
        vreservaesc: permissao.reservaesc,
        vbancolis: permissao.bancolis,
        vbarcolis: permissao.barcolis,
        vcidadelis: permissao.cidadelis,
        vdestinolis: permissao.destinolis,
        vempresalis: permissao.empresalis,
        vfiliallis: permissao.filiallis,
        vgoperacaolis: permissao.gparceirolis,
        vfuncionariolis: permissao.funcionariolis,
        voperacaolis: permissao.operacaolis,
        vparceirolis: permissao.parceirolis,
        vsenha: permissao.senha,
        vpasseiolis: permissao.passeiolis,
        vreservalis: permissao.reservalis,
        vbancoinc: permissao.bancoinc,
        vbarcoinc: permissao.barcoinc,
        vfilialinc: permissao.filialinc,
        vgoperacaoinc: permissao.goperacaoinc,
        vgparceiroinc: permissao.gparceiroinc,
        vfuncionarioinc: permissao.funcionarioinc,
        voperacaoinc: permissao.operacaoinc,
        vpasseioinc: permissao.passeioinc,
        vbancoalt: permissao.bancoalt,
        vbarcoalt: permissao.barcoalt,
        vcidadealt: permissao.cidadealt,
        vdestinoalt: permissao.destinoalt,
        vempresaalt: permissao.empresaalt,
        vfilialalt: permissao.filialalt,
        vgoperacaoalt: permissao.goperacaoalt,
        vgparceiroalt: permissao.gparceiroalt,
        vfuncionarioalt: permissao.funcionarioalt,
        voperacaoalt: permissao.operacaoalt,
        vpasseioalt: permissao.passeioalt,
        vbancoesc: permissao.bancoesc,
        vbarcoesc: permissao.barcoesc,
        vcidadeesc: permissao.cidadeesc,
        vdestinoesc: permissao.destinoesc,
        vempresaesc: permissao.empresaesc,
        vfilialesc: permissao.filialesc,
        vgoperacaoesc: permissao.goperacaoesc,
        vgparceiroesc: permissao.gparceiroesc,
        vfuncionarioesc: permissao.funcionarioesc,
        voperacaoesc: permissao.operacaoesc,
        vpasseioesc: permissao.passeioesc,
        vusuarioalt: permissao.usuarioalt,
        vusuarioesc: permissao.usuarioesc,
        vusuariolis: permissao.usuariolis,
        vnome: permissao.nome,
        vacesso: permissao.acesso
      },
      {
        headers: { Authorization: `Bearer ${applicationData.token}` }
      }
    )
    if (response.status === 200) {
      setType("success")
      setTextAlert(response.statusText)
      setShow(true)
    }
  }

  useEffect(() => {
    ;(async () => {
      const permissaoInfo = await getUsuario(funcionarioID!)

      if (permissaoInfo && !theObjectsAreTheSame(permissao, permissaoInfo)) {
        setPermissao((current: any) => ({ ...current, ...permissaoInfo }))
      }
    })()
  }, [])

  return (
    <div>
      <h2>Gerenciamento de Funcionario</h2>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-4">
          <InputGroup
            className="col-sm-12 col-lg-6"
            label="Nome"
            id="nome"
            type="string"
            value={permissao.nome}
            readOnly
            autoComplete="off"
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-3"
            label="Login"
            id="login"
            type="string"
            value={permissao.login}
            autoComplete="on"
            onChange={(e) => {
              setPermissao({ ...permissao, login: e.target.value })
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            label="Senha"
            id="pass"
            type="password"
            autoComplete="on"
            hasPasswordType={true}
            onChange={(e) => {
              setPermissao({ ...permissao, senha: e.target.value })
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-2 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="status"
            autoComplete="off"
            checked={permissao.status}
            onChange={(e) => {
              setPermissao({ ...permissao, status: e.target.checked })
            }}
          />
          <label htmlFor="status">Ativo</label>
        </div>
      </div>

      <div className="row mt-3"></div>

      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={valueBox}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Inclusão" {...a11yProps(0)} />
            <Tab label="Alteração" {...a11yProps(1)} />
            <Tab label="Exclusão" {...a11yProps(2)} />
            <Tab label="Relatorios" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueBox} index={0}>
          <div className="row mt-3">
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="funcionario"
                checked={permissao.funcionarioinc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    funcionarioinc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="funcionario">Funcionário</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="parceiro"
                checked={permissao.parceiroinc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    parceiroinc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="parceiro">Parceiro</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="reserva"
                checked={permissao.reservainc}
                autoComplete="off"
                onChange={(e) => {
                  if (e.target.value) {
                    setPermissao({
                      ...permissao,
                      reservainc: Boolean(e.target.checked)
                    })
                  }
                }}
              />
              <label htmlFor="reserva">Reserva</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="usuario"
                checked={permissao.usuarioinc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    usuarioinc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="usuario">Usuario</label>
            </div>
          </div>
          <div className="row mt-3"></div>
          <div className="row mt-3">
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="passeio"
                checked={permissao.passeioinc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    passeioinc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="passeio">Passeio</label>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueBox} index={1}>
          <div className="row mt-3">
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="funcionarioalt"
                checked={permissao.funcionarioalt}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    funcionarioalt: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="funcionarioalt">Funcionário</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="parceiroalt"
                checked={permissao.parceiroalt}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    parceiroalt: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="parceiroalt">Parceiro</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="reservaalt"
                checked={permissao.reservaalt}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    reservaalt: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="reservaalt">Reserva</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="usuarioalt"
                checked={permissao.usuarioalt}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    usuarioalt: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="usuarioalt">Usuario</label>
            </div>
          </div>
          <div className="row mt-3"></div>
          <div className="row mt-3">
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="passeioalt"
                checked={permissao.passeioalt}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    passeioalt: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="passeioalt">Passeio</label>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueBox} index={2}>
          <div className="row mt-3">
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="funcionarioexc"
                checked={permissao.funcionarioesc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    funcionarioesc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="funcionarioexc">Funcionário</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="parceiroesc"
                checked={permissao.parceiroesc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    parceiroesc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="parceiroesc">Parceiro</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="reservaesc"
                checked={permissao.reservaesc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    reservaesc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="reservaesc">Reserva</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="usuarioesc"
                checked={permissao.usuarioesc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    usuarioesc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="usuarioesc">Usuario</label>
            </div>
          </div>
          <div className="row mt-3"></div>
          <div className="row mt-3">
          <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="passeioesc"
                checked={permissao.passeioesc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    passeioesc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="passeioesc">Passeio</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="barcoesc"
                checked={permissao.barcoesc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    passeioesc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="barcoesc">Cancelar Reserva</label>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueBox} index={3}>
          <div className="row mt-3">
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="checkin"
                checked={permissao.relrecibo}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    relrecibo: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="checkin">Checkin/Embarque</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="faturamento"
                checked={permissao.relfaturamento}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    relfaturamento: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="faturamento">Faturamento</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="relreserva"
                checked={permissao.relreserva}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    relreserva: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="relreserva">Rel Reservas</label>
            </div>
            <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
              <Checkbox
                appearance="primary"
                id="gerencial"
                checked={permissao.filialesc}
                autoComplete="off"
                onChange={(e) => {
                  setPermissao({
                    ...permissao,
                    filialesc: Boolean(e.target.checked)
                  })
                }}
              />
              <label htmlFor="gerencial">Gerencial</label>
            </div>
          </div>
        </CustomTabPanel>
      </Box>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              gravar()
            }}
          >
            Gravar<IconGoogle>save</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  )
}
